import { render, staticRenderFns } from "./SegmentationDataTypeModal.vue?vue&type=template&id=fa3d781c&scoped=true&"
import script from "./SegmentationDataTypeModal.vue?vue&type=script&lang=js&"
export * from "./SegmentationDataTypeModal.vue?vue&type=script&lang=js&"
import style0 from "./SegmentationDataTypeModal.vue?vue&type=style&index=0&id=fa3d781c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa3d781c",
  null
  
)

export default component.exports